// import SectionHeader from './SectionHeader.jsx';

// const pathCards = [
//   {
//     icon: '\u{1F3D7}\uFE0F',
//     title: 'Build',
//     text: 'Developers who want to build great projects with the right land, the right product strategy, and aligned funding.',
//     features: [
//       'Demand-backed design briefs',
//       'Land sourcing & feasibility',
//       'Capital matchmaking',
//       'Architecture consultation',
//     ],
//     cta: 'Start Building',
//     buttonClass: 'path-btn-outline',
//   },
//   {
//     icon: '\u{1F4B0}',
//     title: 'Raise',
//     text: 'Access structured investment opportunities in high-potential projects with transparent returns and clear timelines.',
//     features: [
//       'Vetted deal flow',
//       'Structured IRR models',
//       'Milestone-based deployment',
//       'Exit clarity from Day 1',
//     ],
//     cta: 'Start Investing',
//     buttonClass: 'path-btn-filled',
//     featured: true,
//   },
//   {
//     icon: '\u{1F30D}',
//     title: 'Invest',
//     text: 'Unlock the true potential of your land through right development strategy, and best-fit developer connections.',
//     features: [
//       'Land potential assessment',
//       'Market positioning report',
//       'Developer introductions',
//       'JV & outright sale structuring',
//     ],
//     cta: 'Evaluate Your Land',
//     buttonClass: 'path-btn-outline',
//   },
// ];

// function PathSection() {
//   return (
//     <section id="path" data-section className="section-path fade-up">
//       <div className="section-wrap">
//         <SectionHeader
//           label="Your Journey"
//           title="Choose Your Path"
//           subtitle="Select the role that fits you best and unlock a tailored Trikon experience."
//         />

//         <div className="path-grid">
//           {pathCards.map((card) => (
//             <div key={card.title} className={`path-card${card.featured ? ' featured' : ''}`}>
//               <div
//                 className="path-icon"
//                 style={
//                   card.featured
//                     ? {
//                         background: 'rgba(0,212,200,.25)',
//                         borderColor: 'rgba(0,212,200,.5)',
//                       }
//                     : undefined
//                 }
//               >
//                 {card.icon}
//               </div>
//               <div className="path-title">{card.title}</div>
//               <p className="path-text">{card.text}</p>
//               <ul className="path-features">
//                 {card.features.map((feature) => (
//                   <li key={feature}>{feature}</li>
//                 ))}
//               </ul>
//               <a href="#contact" className={`path-btn ${card.buttonClass}`}>
//                 {card.cta}
//               </a>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// export default PathSection;


import SectionHeader from './SectionHeader.jsx';

const pathCards = [
  {
    title: 'Build',
    description: 'Developers who want to build great projects with the right land, the right product strategy, and aligned funding.',
    features: [
      'Demand-backed design briefs',
      'Land sourcing & feasibility',
      'Capital matchmaking',
      'Architecture consultation',
    ],
    cta: 'Start Building',
  },
  {
    title: 'Raise',
    description: 'Access structured investment opportunities in high-potential projects with transparent returns and clear timelines.',
    features: [
      'Vetted deal flow',
      'Structured IRR models',
      'Milestone-based deployment',
      'Exit clarity from Day 1',
    ],
    cta: 'Start Investing',
  },
  {
    title: 'Invest',
    description: 'Unlock the true potential of your land through right development strategy, and best-fit developer connections.',
    features: [
      'Land potential assessment',
      'Market positioning report',
      'Developer introductions',
      'JV & outright sale structuring',
    ],
    cta: 'Evaluate Your Land',
  },
];

function PathSection() {
  return (
    <section id="path" data-section className="section-path fade-up">
      <div className="section-wrap">
        <SectionHeader
          label="Your Journey"
          title="Choose Your Path"
          subtitle="Select the role that fits you best and unlock a tailored Trikon experience."
        />

        <div className="path-grid">
          {pathCards.map((card) => (
            <div key={card.title} className="path-column">
              <h3 className="path-column-title">{card.title}</h3>
              <p className="path-column-description">{card.description}</p>
              <ul className="path-list">
                {card.features.map((feature) => (
                  <li key={feature} className="path-list-item">
                    {/* <span className="path-check">✓</span> */}
                    {feature}
                  </li>
                ))}
                <li className="path-list-item path-list-cta"  style={{ fontSize:'18px', marginTop:'20px' }}>
                  {card.cta}
                  <span className="path-arrow">→</span>
                </li>
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PathSection;

